import React, { useEffect, useState } from "react";
import ImgVerified from "../../../../components/imgVerified/ImgVerified";
import axios from "axios";
import { useAuth, useTheme } from "../../../../global-components/src";
import { useMessage } from "../../../../global-components/src";
import { Link, useNavigate } from "react-router-dom";
import { errorMessage } from "../../../../utils/TextManagerTwo";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../../global-components/src/utils/vars";
import { Frame } from "../../../../components/Post/ImgProfilePost/frame";
import { Community, User } from "../../../../global-components/src/types";
import { t } from "i18next";
import { getImageUserNotFound, isEveryOnline } from "../../../../global-components/src/utils/auth";
import BottomSheet from "../../../../global-components/bottom-sheet/bottom-sheet";
import { Icon } from "../../../../global-components/src/components/icon";
import { ChevronDown, Shield, ShieldCheck, ShieldOff, UserPlus, UserRoundMinus, UserRoundX, UserX } from "lucide-react";
import { canAnimateProfilePhoto, FreezeGif } from "../../../Account/freeze-gif";

interface UserSearchProps {
    user: User;
    hideFollowUser?: boolean;
    isBtnFollowUser?: boolean;
    clasNameSearch?: string
    onClick?: any
    clasImgAccount?: string
    community?: Community | null
    setUsers?: React.Dispatch<React.SetStateAction<User[] | null>>
    setAdmins?: React.Dispatch<React.SetStateAction<User[] | null>>
    isMyFollowers?: boolean
    setFollowers?: React.Dispatch<React.SetStateAction<User[] | null>>
}

const UserSearch: React.FC<UserSearchProps> = ({ user, clasNameSearch, clasImgAccount, hideFollowUser, isBtnFollowUser=false, onClick, community, setUsers, setAdmins, isMyFollowers, setFollowers }) => {
    const [isFollowing, setIsFollowing] = useState<boolean | undefined>(user?.is_following);
    const [isFollowed, setIsFollowed] = useState<boolean | undefined>(user?.is_followed);
    const { token, user: userAuthenticated } = useAuth();
    const { setMessage } = useMessage()
    const { isDarkMode } = useTheme()
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 850);
    const [openSheet, setOpenSheet] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 850);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleFollowUser = async () => {
        const newFollowing = !isFollowing;
        const url = PACOCA_API_URL + "/users/" + (newFollowing ? "follow" : "unfollow") + "/" + user?.id;
        setIsFollowing(newFollowing);

        try {
            await axios.post(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            })

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            if(err.status != 403){
                const newisFollowing = isFollowing;
                setIsFollowing(newisFollowing);
                setMessage(messageError, type)
            } 
            console.error('Erro:', err);
        }
    }


    return (
        <>
        {/* notification_opened */}
            <div key={user?.id} className={`${user?.active_frame?.image_path ? "row-notification-with-frame" : "" } row-notification open-notification row-user`} style={{ position: "relative" }}>
                <div style={{ position: "relative" }}>
                    {user?.active_frame?.image_path &&
                        <Frame onClick={() => navigate(`/@${user?.user_name}`)} path={`${BUCKET_PACOCA_URL}/${user.active_frame?.image_path}`} className={`cursor-pointer frame-${(clasImgAccount ?? "img-account-search img-notification").trim().split(/\s+/).pop()}`}/>
                    }
                    <FreezeGif
                        onClick={() => navigate(`/@${user?.user_name}`)}
                        className={`user-select-none col-1 ${clasImgAccount ? clasImgAccount : "img-account-search img-notification"}`}
                        src={user?.img_account ? (BUCKET_PACOCA_URL + "/" + user?.img_account) : getImageUserNotFound(user.name)}
                        fallbackSrc={getImageUserNotFound(user.name)}
                        shouldAnimate={canAnimateProfilePhoto(user?.stamps)}
                        onError={(e) => { e.currentTarget.src = getImageUserNotFound(user.name); }}
                    />
                    {(user?.is_online || isEveryOnline(user?.id)) && (
                        <div className="active-user-chat"></div>
                    )}
                </div>
                <div className="col" style={{ paddingLeft: "0px", paddingRight: "5px", overflow: "hidden", textOverflow: "ellipsis", position: "relative" }} onClick={onClick ? onClick : () => navigate(`/@${user?.user_name}`)}>
                    <h5 className={`${clasNameSearch ? clasNameSearch : "h5-name-search"}`} style={{ overflowWrap: "anywhere", whiteSpace: "nowrap", marginBottom: "2px" }}>
                        {!onClick ? ( 
                            <Link className="name-search" style={{ marginRight: 5 }} to={`/@${user?.user_name}`}>{user?.name}</Link>
                        ): (
                            <span className="name-search" style={{ marginRight: 5 }}>{user?.name}</span>
                        )}
                        <ImgVerified user={user} classNameProp="user-select-none img-verificado-comentario" />
                    </h5>
                    
                    <p className="username-search" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>@{user?.user_name}</p>
                </div>
                {user?.id != userAuthenticated?.id && !hideFollowUser ? (
                    <div className="col-md-3 col-lg-3 col-5" style={{ display: "flex", justifyContent: "end", alignItems: "center", textAlign: "end", marginRight: user?.id != userAuthenticated?.id && isMyFollowers ? 40 : 0, marginTop: -5 }}>
                        <div className="col col-conversar col-button-account">
                            {isBtnFollowUser ? (
                                <span onClick={handleFollowUser} className={`btn-w-100 btn link-sm ${isFollowing ? "btn-gray" : "btn-blue"} btn-shadow`} style={{ width: "100%" }}>
                                    {isFollowing ? t("user.follow.following") : (isFollowed ? t("user.follow.followBack") : t("user.follow.follow"))}
                                </span>
                            ) : (
                                <span onClick={handleFollowUser} className={`${isFollowing ? "" : "blue"} p-follow-post`} style={{ width: "100%", textAlign: "end", marginTop: "20!important" }}>
                                    {isFollowing ? t("user.follow.following") : (isFollowed ? t("user.follow.followBack") : t("user.follow.follow"))}
                                </span>
                            )}
                        </div>
                    </div>

                ) : null}

                {user?.id != userAuthenticated?.id && community?.can_manage_members && (
                    <div className="col-1 col-conf-post">
                        <div className="dropdown">
                            <button className='none-cel' aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                                <ChevronDown color='var(--color-text-post)' size={20} opacity={.6}/>
                            </button>
                            
                            <button className='none-pc' aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button" onClick={() => setOpenMenu(true)} >
                                <ChevronDown color='var(--color-text-post)' size={20} opacity={.6}/>
                            </button>
        
                            <ul className="dropdown-menu menu-drop none-mobile" style={{ minWidth: "250px" }}>
                                <MembersCommunityOptrions setUsers={setUsers} setAdmins={setAdmins} community={community} user={user} isFollowing={isFollowing} isFollowed={isFollowed} handleFollowUser={handleFollowUser} />
                            </ul>
                        </div>
                    </div>
                )}

                {user?.id != userAuthenticated?.id && isMyFollowers && (
                    <div className="col-1 col-conf-post" style={{ marginTop: 5 }}>
                        <div className="dropdown">
                            <button className='none-cel' aria-label="Opções do seguidor" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                                <ChevronDown color='var(--color-text-post)' size={20} opacity={.6}/>
                            </button>
                            
                            <button className='none-pc' aria-label="Opções do seguidor" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button" onClick={() => setOpenMenu(true)} >
                                <ChevronDown color='var(--color-text-post)' size={20} opacity={.6}/>
                            </button>
        
                            <ul className="dropdown-menu menu-drop none-mobile" style={{ minWidth: "250px" }}>
                                <FollowerOptions user={user} setFollowers={setFollowers} />
                            </ul>
                        </div>
                    </div>
                )}

            </div>

            <BottomSheet disableDrag={true} snapPoints={[0, 0.3, 1]} initialSnap={1} setOpen={setOpenMenu} open={openMenu}>
                <div className="modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                    <div className="modal-content modal-content-likes" id="modal-content-likes">
                        <div className="modal-header modal-header-comments">
                            <div></div>
                        </div>
                        <div className="modal-body modal-body-likes overflow-minus bottom-sheet-profile-settings" style={{ marginTop: 10, marginLeft: 5 }} onClick={() => setOpenMenu(false)}>
                            {community?.can_manage_members && (
                                <MembersCommunityOptrions setUsers={setUsers} setAdmins={setAdmins} community={community} user={user} isFollowing={isFollowing} isFollowed={isFollowed} handleFollowUser={handleFollowUser} />
                            )}
                            {isMyFollowers && (
                                <FollowerOptions user={user} setFollowers={setFollowers} />
                            )}
                        </div>
                    </div>
                </div>
            </BottomSheet>
        </>
    );
};

const FollowerOptions = ({ user, setFollowers }: { user: User | undefined, setFollowers?: React.Dispatch<React.SetStateAction<User[] | null>> }) => {
    const { token } = useAuth();
    const { setMessage } = useMessage();

    const removeFollower = async () => {
        try {
            await axios.delete(`${PACOCA_API_URL}/users/followers/${user?.id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessage(`${user?.name} foi removido dos seus seguidores`, "success");
            setFollowers && setFollowers(prev => prev ? prev.filter(u => u.id !== user?.id) : prev);
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        }
    };

    const blockUser = async () => {
        try {
            await axios.post(`${PACOCA_API_URL}/users/block/${user?.id}`, { blocked_user_id: user?.id }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessage(`${user?.name} foi bloqueado`, "success");
            setFollowers && setFollowers(prev => prev ? prev.filter(u => u.id !== user?.id) : prev);
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        }
    };

    return (
        <>
            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={removeFollower}>
                    <div className="div-icon-fix">
                        <div className="div-icon-block">
                            <UserRoundX data-feather="copy" className="icon-config-post"/>
                            Remover seguidor
                        </div>
                    </div>
                </span>
            </li>
            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={blockUser}>
                    <div className="div-icon-fix">
                        <div className="div-icon-block">
                            <UserX data-feather="copy" className="icon-config-post"/>
                            Bloquear
                        </div>
                    </div>
                </span>
            </li>
        </>
    );
};

const MembersCommunityOptrions = ({ community, user, isFollowing, isFollowed, handleFollowUser, setUsers, setAdmins } : { community?: Community | null, user: User | undefined, isFollowing: boolean | undefined, isFollowed: boolean | undefined, handleFollowUser: () => void, setUsers?: React.Dispatch<React.SetStateAction<User[] | null>>, setAdmins?: React.Dispatch<React.SetStateAction<User[] | null>>  }) => {
    const { token } = useAuth();
    const { setMessage } = useMessage();

    const removeMember = async () => {
        try {
            await axios.delete(`${PACOCA_API_URL}/communities/${community?.id}/members/${user?.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setMessage(`${user?.name} foi removido da comunidade`, "success");
            setUsers && setUsers(prev => {
                if(!prev) return prev;

                return Array.isArray(prev) ? prev.filter(u => u.id !== user?.id) : prev;
            });
            setAdmins && setAdmins(prev => {
                if(!prev) return prev;

                return Array.isArray(prev) ? prev.filter(u => u.id !== user?.id) : prev;
            })
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        }
    };

    const removeAdmin = async () => {
        try {
            await axios.delete(`${PACOCA_API_URL}/communities/${community?.id}/members/${user?.id}/admin`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setMessage(`${user?.name} não é mais administrador da comunidade`, "success");
            setUsers && setUsers(prev => {
                if(!prev) return prev;

                return Array.isArray(prev) ? prev.map(u => u.id === user?.id ? {...u, is_admin: false} : u) : prev;
            });
            setAdmins && setAdmins(prev => {
                if(!prev) return prev;

                return Array.isArray(prev) ? prev.filter(u => u.id !== user?.id) : prev;
            })
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        }
    };

    const addAdmin = async () => {
        try {
            await axios.post(`${PACOCA_API_URL}/communities/${community?.id}/members/${user?.id}/admin`, null, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setMessage(`${user?.name} agora é administrador da comunidade`, "success");
            setUsers && setUsers(prev => {
                if(!prev) return prev;
                return Array.isArray(prev) ? prev.map(u => u.id === user?.id ? {...u, is_admin: true} : u) : prev;
            });
            setAdmins && setAdmins(prev => {
                if(!prev) return prev;
                const userAdmin = Array.isArray(prev) ? prev.find(u => u.id === user?.id) : null;
                if(userAdmin) {
                    return prev.map(u => u.id === user?.id ? {...u, is_admin: true} : u);
                } else {
                    return Array.isArray(prev) ? [...prev, {...user, is_admin: true} as User] : prev;
                }
            });
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        }
    };

    return (
        <>
            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={handleFollowUser}>
                    <div className="div-icon-fix">
                        <div className="div-icon-block">
                            {isFollowing ? <UserRoundMinus data-feather="copy" className="icon-config-post"/> : (isFollowed ? <UserPlus data-feather="copy" className="icon-config-post"/> : <UserPlus data-feather="copy" className="icon-config-post"/>)}
                            {isFollowing ? t("user.follow.following") : (isFollowed ? t("user.follow.followBack") : t("user.follow.follow"))}
                        </div> 
                    </div> 
                </span>
            </li>

            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={removeMember}>
                    <div className="div-icon-fix">
                        <div className="div-icon-block">
                            <UserRoundX data-feather="copy" className="icon-config-post"/>
                            Remover da comunidade
                        </div> 
                    </div> 
                </span>
            </li>
            
            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={user?.is_admin ? removeAdmin : addAdmin}>
                    <div className="div-icon-fix">
                        <div className="div-icon-block">
                            
                            {user?.is_admin ? <ShieldOff data-feather="copy" className="icon-config-post"/> : <ShieldCheck data-feather="copy" className="icon-config-post"/>}
                            {user?.is_admin ? "Remover admin" : "Tornar admin"}
                        </div> 
                    </div> 
                </span>
            </li>
        </>
    )

}

export default UserSearch;